/**
 * Customer-facing feature kill switches.
 */

import { readBoot } from "./boot";

/**
 * `CONNECTORS_UI_ENABLED` — master switch for the provider-agnostic connector UI
 * (Connections tiles from the provider manifest, TrainingPeaks connect flow,
 * dashboard connection cards, sync-now controls). The server manifest remains
 * the runtime kill switch: with `CONNECTORS_ENABLED` or all provider flags off,
 * the UI receives no providers and renders no connector controls.
 */
export const CONNECTORS_UI_ENABLED = true;

/**
 * AI "import your own plan" cards. Server sends `featureFlags.importUi` from
 * whether `OPENAI_API_KEY` is set. Unset/empty → hide. Vite-dev with no boot
 * defaults on so local tests still reach the modal.
 */
export function readImportUiEnabled(): boolean {
  const v = readBoot().featureFlags?.importUi;
  if (typeof v === "boolean") return v;
  return import.meta.env.DEV;
}

export const IMPORT_UI_ENABLED = readImportUiEnabled();

/**
 * Box-review prompt. Server sends `featureFlags.reviewPlans` from
 * `REVIEW_PLANS_ENABLED` — only `1`/`true` turns it on. Unset or any other
 * value stays off. Vite-dev with no boot is off.
 */
export function readReviewPlansEnabled(): boolean {
  return readBoot().featureFlags?.reviewPlans === true;
}
